export const environment = {
  production: false,
  apiUrl: 'https://item2-api.dev.n2m-solution.com',
  cryptoKey: 'e7b5beb95768f5c3526c157d798893a6',
};
